import { render, staticRenderFns } from "./TransportIcon.vue?vue&type=template&id=6bae64ac&lang=pug&"
import script from "./TransportIcon.vue?vue&type=script&lang=js&"
export * from "./TransportIcon.vue?vue&type=script&lang=js&"
import style0 from "./TransportIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
